import { render, staticRenderFns } from "./RegistrationDetails.vue?vue&type=template&id=5e4badb8"
import script from "./RegistrationDetails.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetails.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports